module.exports = __webpack_public_path__ + "static/img/sec1-detail01@m.dd3e6b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-detail01@m.png
// module id = HhY5
// module chunks = 0